import { useEffect, useState } from "react";
export function useCountdown(start, active) {
    const [current, setCurrent] = useState(start);
    // reset `current` when `active` flag flips
    useEffect(() => {
        if (active) {
            setCurrent(start);
        }
    }, [start, active]);
    // count down when active
    useEffect(() => {
        if (active) {
            const tick = window.setInterval(() => setCurrent(current => current - 1), 1000);
            return () => window.clearInterval(tick);
        }
    }, [active]);
    return current;
}
//# sourceMappingURL=countdown.js.map